import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Audiences from '../../views/Audiences';

import { setDataDailyShare, setCompleteDataAudiences } from '../../../actions';

const initialDate = {
  day: moment().format('DD'),
  month: moment().format('MMMM'),
  weekday: moment().format('dddd')
};

class AudiencesWrapper extends Component {
  constructor(props) {
    super(props);

    const {
      dataDailyShare,
      dataRanking,
      dataMonthlyShare,
      dataDailyReports
    } = props;

    this.state = {
      loading: true,
      onErrorLoadData: false,
      dataDailyShare,
      dataRanking,
      dataMonthlyShare,
      dataDailyReports,
      initialDate
    };
  }

  componentDidMount() {
    this.loadAudiencesServices(null);
  }

  onFilterDateHandler = date => () => {
    this.setState({
      loading: true
    });

    this.loadAudiencesServices(date);
  };

  loadAudiencesServices = date => {
    const {
      setDataDailyShareHandler,
      setCompleteDataAudiencesHandler,
      dataDailyShare,
      dataRanking,
      dataMonthlyShare,
      dataDailyReports
    } = this.props;

    setDataDailyShareHandler(date)
      .then(response => {
        this.setState({
          dataDailyShare: response || dataDailyShare
        });

        setCompleteDataAudiencesHandler(response.day)
          .then(data => {
            const [
              dataMonthlyShareLoaded,
              dataDailyReportsLoaded,
              dataRankingLoaded
            ] = data;

            this.setState({
              onErrorLoadData: false,
              dataRanking: dataRankingLoaded || dataRanking,
              dataMonthlyShare: dataMonthlyShareLoaded || dataMonthlyShare,
              dataDailyReports: dataDailyReportsLoaded || dataDailyReports
            });
          })
          .catch(() => {
            this.setState({
              onErrorLoadData: true
            });
          })
          .finally(() => {
            this.setState({
              loading: false
            });
          });
      })
      .catch(() => {
        this.setState({
          onErrorLoadData: true,
          loading: false
        });
      });
  };

  render() {
    const {
      loading,
      onErrorLoadData,
      dataDailyShare,
      dataRanking,
      dataMonthlyShare,
      dataDailyReports,
      initialDate
    } = this.state;

    return (
      <Audiences
        onFilterDate={this.onFilterDateHandler}
        dataDailyShare={dataDailyShare}
        dataRanking={dataRanking}
        dataMonthlyShare={dataMonthlyShare}
        dataDailyReports={dataDailyReports}
        isLoading={loading}
        isOnErrorLoadData={onErrorLoadData}
        initialDate={initialDate}
      />
    );
  }
}

const mapStateToProps = state => ({
  dataDailyShare: state.audiences.dataDailyShare,
  dataRanking: state.audiences.dataRanking,
  dataMonthlyShare: state.audiences.dataMonthlyShare,
  dataDailyReports: state.audiences.dataDailyReports
});

const mapDispatchToProps = dispatch => ({
  setDataDailyShareHandler: date => setDataDailyShare(dispatch, date),
  setCompleteDataAudiencesHandler: date =>
    setCompleteDataAudiences(dispatch, date)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AudiencesWrapper);
